/**
 * Whole months between a group's start date and `asOf` (both "YYYY-MM-DD"),
 * minus one when `asOf`'s day-of-month hasn't reached the start's — the same
 * rule as the sketch's `groupAge`. Never negative.
 */
export function groupAgeMonths(start: string, asOf: string): number {
  const [sy, sm, sd] = start.split('-').map(Number)
  const [ay, am, ad] = asOf.split('-').map(Number)
  if ([sy, sm, sd, ay, am, ad].some((n) => n === undefined || Number.isNaN(n))) return 0
  let months = (ay! - sy!) * 12 + (am! - sm!)
  if (ad! < sd!) months -= 1
  return Math.max(months, 0)
}

/**
 * Compact age label from whole years and months ("1 y 4 mo", "3 mo", "0 mo").
 * `t` is the i18n translate function, resolving `common.yearShort` /
 * `common.monthShort`.
 */
export function groupAgeShort(years: number, months: number, t: (key: string) => string): string {
  const parts: string[] = []
  if (years) parts.push(`${years} ${t('common.yearShort')}`)
  if (months || parts.length === 0) parts.push(`${months} ${t('common.monthShort')}`)
  return parts.join(' ')
}
